import { jsx as _jsx } from "react/jsx-runtime";
import { ReturnToCheckoutExpiredStillAvailable } from "./card-content/expired-still-available/expired-still-available-card.component";
import { ReturnToCheckoutExpiredUnavailable } from "./card-content/expired-unavailable/expired-unavailable-card.component";
import { ReturnToCheckoutExpiringSoon } from "./card-content/expiring-soon/expiring-soon-card.component";
import { LoadingCard } from "./card-content/loading-card/loading-card.component";
import { ReturnToCheckoutOrderActive } from "./card-content/order-active/order-active-card.component";
import Modal from "./modal";
import styles from "./return-to-checkout-modal.module.css";
import { ModalState } from "./return-to-checkout-modal.types";
import { getTitle, noOpTracking, useReturnToCheckoutModal } from "./helpers/return-to-checkout-modal.helpers";
export var CheckoutStage;
(function(CheckoutStage) {
    CheckoutStage["PersonalDetails"] = "PersonalDetails";
    CheckoutStage["PartExchange"] = "PartExchange";
    CheckoutStage["Finance"] = "Finance";
    CheckoutStage["DeliverySlots"] = "DeliverySlots";
    CheckoutStage["Extras"] = "Extras";
    CheckoutStage["CinchCare"] = "CinchCare";
    CheckoutStage["Payment"] = "Payment";
    CheckoutStage["SignUp"] = "SignUp";
})(CheckoutStage || (CheckoutStage = {}));
export var returnToCheckoutOrderActiveTestId = "return-to-checkout-order-active-test-id";
export var returnToCheckoutExpiringSoonTestId = "return-to-checkout-expiring-soon-test-id";
export var returnToCheckoutExpiredStillAvailableTestId = "return-to-checkout-expired-still-available-test-id";
export var returnToCheckoutExpiredUnavailableTestId = "return-to-checkout-expired-unavailable-test-id";
export var i18n = {
    orderActive: {
        title: "Continue buying this car?",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiringSoon: {
        title: "Your order is timing out",
        text: "We'll reserve this car for another {bold}{timeRemaining}{/bold}",
        buttonText: "Return to checkout",
        secondaryButtonText: "I don't want this car"
    },
    expiredStillAvailable: {
        title: "Your order timed out",
        text: "But the car is still available! Want to start a new order with the same car?",
        buttonText: "Go to checkout"
    },
    expiredUnavailable: {
        title: "Car no longer available",
        text: "We’re sorry you missed it - but we have 1,000s of other cars in stock. Start a new search to find yours.",
        buttonText: "Browse all cars"
    },
    loading: "Loading...",
    adminFee: "Plus a {adminFeeValue} admin fee"
};
export var ReturnToCheckoutModal = function(param) {
    var activeOrder = param.activeOrder, onClose = param.onClose, lastVisitedCheckoutStage = param.lastVisitedCheckoutStage, timeRemainingInSeconds = param.timeRemainingInSeconds, withinExpiryTimeWindow = param.withinExpiryTimeWindow, _adminFeeFlag = param.adminFeeFlag, adminFeeFlag = _adminFeeFlag === void 0 ? false : _adminFeeFlag, _adminFeeValueInPence = param.adminFeeValueInPence, adminFeeValueInPence = _adminFeeValueInPence === void 0 ? 0 : _adminFeeValueInPence, cancelOrder = param.cancelOrder, isLoggedIn = param.isLoggedIn, accessToken = param.accessToken, refreshActiveOrder = param.refreshActiveOrder, checkIfVehicleIsReserved = param.checkIfVehicleIsReserved, extendOrderExpiryDate = param.extendOrderExpiryDate, trackEvent = param.trackEvent, handleShouldShowBasketIcon = param.handleShouldShowBasketIcon;
    var ref = useReturnToCheckoutModal({
        activeOrder: activeOrder,
        timeRemainingInSeconds: timeRemainingInSeconds,
        withinExpiryTimeWindow: withinExpiryTimeWindow,
        checkIfVehicleIsReserved: checkIfVehicleIsReserved,
        accessToken: accessToken,
        extendOrderExpiryDate: extendOrderExpiryDate,
        refreshActiveOrder: refreshActiveOrder,
        cancelOrder: cancelOrder,
        onClose: onClose,
        isLoggedIn: isLoggedIn,
        handleShouldShowBasketIcon: handleShouldShowBasketIcon,
        lastVisitedCheckoutStage: lastVisitedCheckoutStage,
        trackEvent: trackEvent
    }), vehicle = ref.vehicle, orderHasExpired = ref.orderHasExpired, timeLeft = ref.timeLeft, buttonLoading = ref.buttonLoading, secondaryButtonLoading = ref.secondaryButtonLoading, vehicleIsReserved = ref.vehicleIsReserved, modalLoading = ref.modalLoading, expiringSoon = ref.expiringSoon, handleRemoveOrder = ref.handleRemoveOrder, onModalOpen = ref.onModalOpen, onModalClose = ref.onModalClose, onButtonClick = ref.onButtonClick, onButtonClickExpiredOrderVehicleStillAvailable = ref.onButtonClickExpiredOrderVehicleStillAvailable, onButtonClickExpiredOrderVehicleUnavailable = ref.onButtonClickExpiredOrderVehicleUnavailable, onModalCloseExpiredOrderVehicleUnavailable = ref.onModalCloseExpiredOrderVehicleUnavailable;
    if (modalLoading || !activeOrder) {
        return /*#__PURE__*/ _jsx(Modal, {
            onClose: onClose,
            title: "Loading",
            classNames: styles,
            closeable: true,
            children: /*#__PURE__*/ _jsx(LoadingCard, {})
        });
    }
    if (orderHasExpired) {
        if (!vehicleIsReserved) {
            var returnToCheckoutModalState = ModalState.expiredStillAvailable;
            return /*#__PURE__*/ _jsx(Modal, {
                testId: returnToCheckoutExpiredStillAvailableTestId,
                onClose: function() {
                    return onModalClose(returnToCheckoutModalState);
                },
                classNames: styles,
                closeable: true,
                children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiredStillAvailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleStillAvailable,
                    title: getTitle(returnToCheckoutModalState),
                    vehicle: vehicle,
                    i18n: i18n.expiredStillAvailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        } else {
            var returnToCheckoutModalState1 = ModalState.expiredUnavailable;
            return /*#__PURE__*/ _jsx(Modal, {
                testId: returnToCheckoutExpiredUnavailableTestId,
                onClose: onModalCloseExpiredOrderVehicleUnavailable,
                classNames: styles,
                closeable: true,
                children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiredUnavailable, {
                    adminFeeFlag: adminFeeFlag,
                    adminFeeValueInPence: adminFeeValueInPence,
                    onButtonClick: onButtonClickExpiredOrderVehicleUnavailable,
                    title: getTitle(returnToCheckoutModalState1),
                    vehicle: vehicle,
                    i18n: i18n.expiredUnavailable,
                    isButtonLoading: buttonLoading,
                    trackEvent: trackEvent,
                    noOpTracking: noOpTracking,
                    onModalOpen: onModalOpen
                })
            });
        }
    }
    if (expiringSoon) {
        var returnToCheckoutModalState2 = ModalState.expiringSoon;
        return /*#__PURE__*/ _jsx(Modal, {
            testId: returnToCheckoutExpiringSoonTestId,
            onClose: function() {
                return onModalClose(returnToCheckoutModalState2);
            },
            classNames: styles,
            closeable: true,
            children: /*#__PURE__*/ _jsx(ReturnToCheckoutExpiringSoon, {
                adminFeeFlag: adminFeeFlag,
                adminFeeValueInPence: adminFeeValueInPence,
                title: getTitle(returnToCheckoutModalState2),
                timeRemainingInSeconds: timeLeft,
                onButtonClick: function() {
                    return onButtonClick();
                },
                onSecondaryButtonClick: function() {
                    return handleRemoveOrder();
                },
                vehicle: vehicle,
                isButtonLoading: buttonLoading,
                isSecondaryButtonLoading: secondaryButtonLoading,
                i18n: i18n.expiringSoon,
                noOpTracking: noOpTracking,
                trackEvent: trackEvent,
                onModalOpen: onModalOpen
            })
        });
    }
    var returnToCheckoutModalState3 = ModalState.active;
    return /*#__PURE__*/ _jsx(Modal, {
        testId: returnToCheckoutOrderActiveTestId,
        onClose: function() {
            return onModalClose(returnToCheckoutModalState3);
        },
        classNames: styles,
        closeable: true,
        children: /*#__PURE__*/ _jsx(ReturnToCheckoutOrderActive, {
            adminFeeFlag: adminFeeFlag,
            adminFeeValueInPence: adminFeeValueInPence,
            onButtonClick: function() {
                return onButtonClick();
            },
            onSecondaryButtonClick: function() {
                return handleRemoveOrder();
            },
            title: getTitle(returnToCheckoutModalState3),
            vehicle: vehicle,
            i18n: i18n.orderActive,
            isButtonLoading: buttonLoading,
            isSecondaryButtonLoading: secondaryButtonLoading,
            trackEvent: trackEvent,
            noOpTracking: noOpTracking,
            onModalOpen: onModalOpen
        })
    });
};
export default ReturnToCheckoutModal;
